import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form';
import {
  Label
} from "@progress/kendo-react-labels";
import React, { FunctionComponent } from 'react'
import { TicketApi } from '../../../redux/api/TicketApi';

const PriorityList: FunctionComponent<FieldRenderProps> = props => {
  const { data: priorities } = TicketApi.useGetPriorityListQuery(props.prioritySetId, { skip: !props.prioritySetId });
  const {
    label,
    id,
    valid,
    disabled,
    optional,
    selectedPriority,
    priorityChangeHandler,
  } = props;
  return (
    <FieldWrapper>
      {label && <Label
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
        optional={optional}
      >
        {label}
      </Label>}
      <div className={"k-form-field-wrap"}>
        <DropDownList popupSettings={{ className: 'z500' }} onChange={priorityChangeHandler} value={selectedPriority} data={priorities} dataItemKey="ID" textField="Priority_Level" />
      </div>
    </FieldWrapper>
  )
}

export default PriorityList;